"use client";

import { Fragment } from "react";
import { ArrowRight, ClipboardList, Stethoscope, Plane, HeartPulse } from "lucide-react";
import { howItWorksSteps } from "@/data/mockData";
import { useI18n } from "@/i18n/I18nProvider";

const iconMap: Record<string, React.ComponentType<{ size?: number; className?: string; strokeWidth?: number }>> = {
  "clipboard-list": ClipboardList,
  "user-check": Stethoscope,
  plane: Plane,
  "heart-pulse": HeartPulse,
};

export default function HowItWorks() {
  const { t } = useI18n();
  return (
    <section className="px-5 mt-3">
      <h3 className="text-[17px] font-bold text-text-dark tracking-[-0.2px] mb-2.5">
        {t("How It Works")}
      </h3>
      <div className="flex items-start justify-between">
        {howItWorksSteps.map((step, i) => {
          const Icon = iconMap[step.icon] ?? ClipboardList;
          return (
            <Fragment key={step.step}>
              <div className="flex flex-col items-center w-[72px] shrink-0">
                <div className="w-[38px] h-[38px] rounded-full bg-[#EAF7F3] flex items-center justify-center">
                  <Icon size={18} strokeWidth={2} className="text-primary" />
                </div>
                <p className="mt-2 text-[12px] leading-[1.35] text-text-dark text-center">
                  <span className="font-bold text-primary">{step.step}</span>{" "}
                  <span className="font-medium">{t(step.title)}</span>
                </p>
              </div>
              {i < howItWorksSteps.length - 1 && (
                <ArrowRight size={13} className="mt-[12px] shrink-0 text-text-dark/25" />
              )}
            </Fragment>
          );
        })}
      </div>
    </section>
  );
}
